<div class="modal-header card-header">
    <div class="col-10 d-flex align-items-center" style="min-width: 0;">
        <img *ngIf="ficha?.jugador.imagen" width="45" height="45" class="radius-round mr-2" style="object-fit: cover;" alt="foto" [src]="rest_server+ficha.jugador.imagen" />
        <div style="min-width: 0;">
            <span class="text-blue text-125 text-truncate d-block">{{ficha?.jugador.nombre_completo || 'Jugador'}}</span>
            <span *ngIf="ficha" class="text-grey-m1 text-90">C.I. {{ficha.jugador.ci || '-'}} · Código {{ficha.jugador.codigo || '-'}}</span>
        </div>
    </div>
    <div class="col-2 text-right">
        <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
            <i class="fa fa-times red2 text-110"></i>
        </button>
    </div>
</div>
<div class="modal-body card-body">
    <div *ngIf="cargando" class="text-center text-grey p-3">Cargando...</div>
    <ng-container *ngIf="!cargando && ficha">
        <div class="d-flex justify-content-between align-items-center radius-1 p-2 mb-3" [ngClass]="ficha.total>0?'bgc-red-l4':'bgc-green-l4'">
            <span class="text-dark-m2">Deuda total del jugador</span>
            <span class="font-bolder text-125" [ngClass]="ficha.total>0?'text-danger-d1':'text-success-d1'">Bs {{ficha.total | number:'1.2-2'}}</span>
        </div>

        <div class="text-grey-d1 text-uppercase text-80 mb-1">Deudas pendientes</div>
        <div *ngIf="ficha.deudas.length==0" class="text-grey-d1 text-90 mb-3">El jugador no tiene deudas pendientes.</div>
        <div *ngFor="let deuda of ficha.deudas" class="d-flex justify-content-between align-items-center border-b-1 brc-grey-l3 py-1 text-90">
            <div class="pr-2" style="min-width: 0;">
                <div>{{deuda.concepto}}</div>
                <div class="text-grey text-85">
                    {{deuda.fecha | date:'dd/MM/yyyy'}} · {{deuda.club}} · {{deuda.campeonato}}
                    <span class="badge badge-sm ml-1" [ngClass]="deuda.tipo=='PERSONAL'?'bgc-red-l3':'bgc-blue-l3'">{{deuda.tipo=='PERSONAL'?'Personal':'Su parte de Bs '+(deuda.monto | number:'1.2-2')}}</span>
                </div>
            </div>
            <div class="text-right text-nowrap">
                <div class="font-bolder">Bs {{deuda.saldo | number:'1.2-2'}}</div>
                <a class="btn radius-1 btn-xs btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success px-1" href="javascript:void(0)" title="Pagar su parte" (click)="pagarDeuda(deuda)">
                    <i class="fa fa-money-bill-alt text-105"></i>
                </a>
            </div>
        </div>

        <div class="text-grey-d1 text-uppercase text-80 mt-3 mb-1">Pagos del jugador</div>
        <div *ngIf="ficha.pagos.length==0" class="text-grey-d1 text-90">El jugador todavía no registró pagos propios.</div>
        <div *ngFor="let pago of ficha.pagos" class="d-flex justify-content-between border-b-1 brc-grey-l3 py-1 text-90">
            <div class="pr-2" style="min-width: 0;">
                <div>{{pago.concepto}}</div>
                <div class="text-grey text-85">{{pago.fecha | date:'dd/MM/yyyy'}} · {{pago.club}} · Recibo Nº {{pago.numero_documento}}</div>
            </div>
            <div class="text-nowrap text-success-d1 font-bolder">Bs {{pago.monto_pagado | number:'1.2-2'}}</div>
        </div>
    </ng-container>
</div>
